<template>
    <div v-bind="$attrs" style="margin-top: -0.1rem">
        <v-tooltip top>
            <template #activator="{ on }">
                <div v-clipboard:copy="value.toString()" class="clickable d-inline-block" v-on="on" @click.stop>
                    <div class="d-flex" v-bind="$attrs">
                        <div style="margin-top: -0.1rem">
                            <v-icon small>mdi-content-copy</v-icon>
                        </div>
                        <div class="ml-1">
                            <slot></slot>
                        </div>
                    </div>
                </div>
            </template>
            <span>Click to copy</span>
        </v-tooltip>
    </div>
</template>

<script>
export default {
    name: 'CopyValue',

    props: {
        value: {
            type: [String, Number],
            required: true,
        },
    },
};
</script>
